import PouchDB from "pouchdb";
import PouchDBFind from "pouchdb-find";
import PouchDBAuthentication from "pouchdb-authentication";
import eventBus from "@/eventBus";

PouchDB.plugin(PouchDBFind);
PouchDB.plugin(PouchDBAuthentication);

function copy(obj) {
  return JSON.parse(JSON.stringify(obj));
}

export default class Database {
  constructor(local, remote, primary = 0) {
    this.localDB = new PouchDB(local);
    this.remoteDB = new PouchDB(remote);
    if (primary === 0) {
      this.primaryDB = this.localDB;
    } else {
      this.primaryDB = this.remoteDB;
    }
  }
  createIndices(...indices) {
    for (const index of indices) {
      this.primaryDB.createIndex({
        index: {
          fields: index,
          name: `idx-${index.join("-")}`,
          ddoc: `dd-${index.join("-")}`,
          type: "json"
        }
      });
    }
  }

  sync() {
    const db_name = this.localDB.name;
    return this.localDB
      .sync(this.remoteDB.name, {
        live: true,
        retry: true
      })
      .on("change", function() {})
      .on("paused", function() {
        eventBus.$emit("sync-paused", {
          message: "Data sync completed",
          on: db_name,
          at: new Date().toISOString()
        });
      })
      .on("active", function() {
        eventBus.$emit("sync-active", {
          message: "Data is being synced",
          on: db_name,
          at: new Date().toISOString()
        });
      })
      .on("error", function(err) {
        eventBus.$emit("sync-failed", {
          message: err.message || "Sync failed",
          on: db_name,
          at: new Date().toISOString()
        });
      });
  }
  login(username, password) {
    return this.remoteDB.login(username, password);
  }

  logout() {
    return this.remoteDB.logOut();
  }

  get(id) {
    return this.primaryDB.get(id);
  }

  fetchRecords(selector) {
    return this.find({ selector: { ...selector } });
  }

  find(query) {
    console.log(JSON.stringify(query));
    return this.primaryDB.find(copy(query));
  }

  insert(data) {
    return this.primaryDB.post(copy(data));
  }

  /**
   * Updates/Creates a new record in the database.
   * @param data {Object} -> the data to be updated/created
   * @return {Promise}
   */
  save(data) {
    return this.primaryDB.put(copy(data));
  }

  saveMany(data) {
    return this.primaryDB.bulkDocs(copy(data));
  }
}
